import { plannerStore } from "../../App";
import { useEffect, useState } from "react";

export default function Review({ onClose }) {
  const { color, letters, sizeSelected, borderSelected, templateSelected } =
    plannerStore();

  return (
    <div>
      <div className="flex flex-row">
        <div className="flex flex-col">
          <h1 className="text-lg">Custom Planner</h1>
          <h3 className="text-md ">Planner with no mono</h3>
          <div className="flex flex-row">
            <p>This is where the pic would be like a planner pic or whatever</p>
            <p>x1 (this is where the number amount will be)</p>
          </div>
          <button
            className="bg-blue-300 text-white w-auto rounded-lg"
            onClick={onClose}
          >
            Continue to Checkout Page
          </button>
        </div>
      </div>
    </div>
  );
}
